<template>
  <div class="transversus-tag-style">
    <el-collapse style="margin-bottom: 20px" v-model="tagCollapse" accordion>
      <div v-for="(item, index) in collapseList">
        <el-collapse-item
          v-if="index == 0"
          :title="item.title"
          :name="item.name"
        >
          <el-form
            label-width="90px"
            :model="datas"
            size="small"
            class="lef"
            style="margin-top: 20px"
          >
            <el-form-item label="模块名称：">
              <div class="weiz">
                <div class="ml35">
                  <el-input disabled v-model="datas.moduleName"></el-input>
                </div>
              </div>
            </el-form-item>
            <div class="tag-table-container">
              <div class="title-container">
                <span class="title">标签列表</span>
                <span class="add-btn" @click="addTag">添加标签</span>
              </div>
              <table class="tag-table">
                <thead>
                  <tr>
                    <th>标签名称</th>
                    <th>排序</th>
                    <th>操作</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in tagListClone" :key="index">
                    <td>
                      <van-field
                        v-model="item.name"
                        @input="updateTag($event, item, index)"
                        @blur="updateTagBlur($event, item, index)"
                      />
                    </td>
                    <td class="sort-icon">
                      <!-- 这里用了 Font Awesome 图标，也可以换成项目里的图标库 -->
                      <i
                        v-if="index !== 0"
                        class="el-icon-top"
                        :style="{
                          color: tagListClone.length > 1 ? '' : 'transparent',
                        }"
                        @click="moveUp(index)"
                      ></i>
                      <!-- 下移：不是最后一行才显示 -->
                      <i
                        v-if="index !== tagListClone.length - 1"
                        class="el-icon-bottom"
                        @click="moveDown(index)"
                      ></i>
                    </td>
                    <td
                      class="action-buttons"
                      style="display: flex; justify-content: center"
                    >
                      <button class="view-btn">
                        <i
                          class="el-icon-view"
                          :style="{
                            color: tagListClone.length > 1 ? '' : 'transparent',
                          }"
                        ></i>
                      </button>
                      <button class="delete-btn">
                        <i
                          v-if="tagListClone.length > 1"
                          class="el-icon-delete"
                          @click="deleteTag(item, index)"
                        ></i>
                        <el-tooltip
                          v-else
                          class="item"
                          effect="dark"
                          content="至少保留一项标签"
                          placement="top-start"
                        >
                          <i
                            class="el-icon-delete"
                            style="color: #cccccc"
                            :style="{
                              cursor:
                                tagListClone.length > 1
                                  ? 'pointer'
                                  : 'not-allowed',
                            }"
                          ></i>
                        </el-tooltip>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <el-collapse
              style="margin-bottom: 20px"
              v-model="activeNames"
              accordion
            >
              <el-collapse-item title="选中状态" name="1">
                <!-- 选中状态 -->
                <el-form-item
                  label="字体："
                  prop="fontWeight"
                  :hide-required-asterisk="true"
                >
                  <div class="weiz">
                    <div class="ml35">
                      <el-select
                        v-model="datas.fontFamily"
                        placeholder="请选择字体"
                      >
                        <el-option
                          v-for="item in fontFamilyOptions"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        >
                        </el-option>
                      </el-select>
                    </div>
                  </div>
                </el-form-item>
                <!-- 标题大小 -->
                <el-form-item
                  label="字号："
                  prop="wordSize"
                  :hide-required-asterisk="true"
                >
                  <div class="weiz">
                    <div class="ml35">
                      <el-select
                        v-model="datas.fontSize"
                        placeholder="请选择字号"
                      >
                        <el-option
                          v-for="item in wordSizeOptions"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        >
                        </el-option>
                      </el-select>
                    </div>
                  </div>
                </el-form-item>
                <!-- 文字颜色 -->
                <el-form-item class="lef" label="颜色：">
                  <div class="weiz">
                    <!-- 1. 修改文字显示逻辑，新增居右判断 -->
                    <div style="margin-left: 35px">
                      <el-color-picker
                        v-model="datas.activeColor"
                        show-alpha
                        @change="handleCustomColorChange($event, 'activeColor')"
                      ></el-color-picker>
                    </div>
                    <div>
                      <el-input
                        placeholder="请输入文字颜色"
                        v-model="datas.activeColor"
                      >
                      </el-input>
                    </div>
                  </div>
                </el-form-item>
                <!-- 背景颜色 -->
                <el-form-item class="lef" label="背景：">
                  <div class="weiz">
                    <div class="ml35">
                      <!--背景颜色子组件 -->
                      <LinkInput
                        :datas="datas"
                        field="activeBackgroundColor"
                        defaultColor="defaultActiveBackgroundColor"
                        type="color"
                      />
                    </div>
                  </div>
                </el-form-item>
              </el-collapse-item>
              <el-collapse-item title="未选中状态" name="2">
                <!-- 未选中状态 -->
                <el-form-item
                  label="字体："
                  prop="fontWeight"
                  :hide-required-asterisk="true"
                >
                  <div class="weiz">
                    <div class="ml35">
                      <el-select
                        v-model="datas.fontFamily"
                        placeholder="请选择字体"
                      >
                        <el-option
                          v-for="item in fontFamilyOptions"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        >
                        </el-option>
                      </el-select>
                    </div>
                  </div>
                </el-form-item>
                <!-- 标题大小 -->
                <el-form-item
                  label="字号："
                  prop="wordSize"
                  :hide-required-asterisk="true"
                >
                  <div class="weiz">
                    <div class="ml35">
                      <el-select
                        v-model="datas.fontSize"
                        placeholder="请选择字号"
                      >
                        <el-option
                          v-for="item in wordSizeOptions"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        >
                        </el-option>
                      </el-select>
                    </div>
                  </div>
                </el-form-item>
                <!-- 文字颜色 -->
                <el-form-item class="lef" label="颜色：">
                  <div class="weiz">
                    <!-- 1. 修改文字显示逻辑，新增居右判断 -->
                    <div style="margin-left: 35px">
                      <el-color-picker
                        v-model="datas.offActiveColor"
                        show-alpha
                        @change="
                          handleCustomColorChange($event, 'offActiveColor')
                        "
                      ></el-color-picker>
                    </div>
                    <div>
                      <el-input
                        placeholder="请输入文字颜色"
                        v-model="datas.offActiveColor"
                      >
                      </el-input>
                    </div>
                  </div>
                </el-form-item>
                <!-- 背景颜色 -->
                <el-form-item class="lef" label="背景：">
                  <div class="weiz">
                    <div class="ml35">
                      <!--背景颜色子组件 -->
                      <LinkInput
                        :datas="datas"
                        field="offBackgroundColor"
                        defaultColor="defaultOffBackgroundColor"
                        type="color"
                      />
                    </div>
                  </div>
                </el-form-item>
              </el-collapse-item>
            </el-collapse>
            <!-- 卡片样式选择 -->
            <el-form-item class="lef" label="模块样式：">
              <div class="weiz">
                <div class="weiz-container" style="">
                  <!-- 模块样式 -->
                  <div
                    v-for="(item, index) in moduleStyleList"
                    :key="index"
                    @click="clickChange(item, index)"
                    class="preview-item"
                    :class="{ active: moduleStyleType == item.moduleStyleType }"
                  >
                    <RightPanelModuleStyle
                      :datas="item"
                      :imagePath="item.src"
                    ></RightPanelModuleStyle>
                  </div>
                </div>
              </div>
            </el-form-item>
          </el-form>
        </el-collapse-item>
        <el-collapse-item
          v-if="index == 1"
          :title="item.title"
          :name="item.name"
        >
          <component
            ref="ChildrenRightPanel"
            v-if="currentComponent"
            :is="currentComponent.style"
            :datas="currentComponent.setStyle"
            :isShow="currentComponent.isShow"
            :data-type="currentComponent.type"
          >
          </component>
        </el-collapse-item>
      </div>
    </el-collapse>
  </div>
</template>

<script>
// 引入事件总线
import Bus from "@/utils/bus.js";
import {
  wordSizeOptions,
  fontFamilyOptions,
  predefineColors,
  searchOptions,
} from "@/utils/defaultData.js";
export default {
  name: "transversustagstyle",
  props: {
    datas: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      collapseList: [
        {
          title: this.datas.moduleName,
          name: "transversustagstyle",
        },
      ],
      tagCollapse: "transversustagstyle",
      activeNames: ["1"],
      currentStyle: {},
      nextIndex: 1, // 全局自增序号
      moduleStyleType: 2, //默认选中的模块样式
      // 构造模块样式列表
      moduleStyleList: [
        { ...this.datas, src: this.$imagePath.image18, moduleStyleType: 2 },
        {
          ...this.datas,
          src: this.$imagePath.image19,
          moduleStyleType: 3,
        },
        {
          ...this.datas,
          src: this.$imagePath.image20,
          moduleStyleType: 4,
        },
        {
          ...this.datas,
          src: this.$imagePath.image21,
          moduleStyleType: 5,
        },
      ],
      // 克隆标签对象
      tagListClone: [],
    };
  },
  computed: {
    // 从 Vuex 状态中获取当前选中的组件（横向标签组件）
    currentComponent() {
      return this.$utils.isEmptyObject(
        this.$store.state.modules.currentComponent,
      )
        ? null
        : this.$store.state.modules.currentComponent;
    },
  },
  watch: {
    datas: {
      handler(newVal, oldVal) {
        if (newVal.tagList[newVal.activeIndex].comList) {
          this.currentStyle = newVal.tagList[newVal.activeIndex].comList[0];
          // 判断横向标签对应右侧面板显示是否显示模块名称输入框
          if (this.currentStyle) {
            this.currentStyle.setStyle.isShowModuleName = true;
          }
        }
        this.$store.commit("modules/SET_CURRENT_COMPONENT", this.currentStyle);
        console.log(
          "有咩有属性",
          newVal,
          this.currentStyle,
          this.$store.state.modules,
        );

        // 每次更新数据时获取下一个自增序号
        this.getNextIndex();
        console.log(
          "横向标签右侧面板区域监听监听家庭daatasdatas",
          newVal,
          this.currentStyle,
          this.datas,
          this.nextIndex,
        );
      },
      deep: true,
    },
  },
  created() {
    this.tagListClone = this.datas.tagList;
    console.log(
      "11从vuex中 状态中获取当前选中的组件（横向标签组件）11111111111111111111111",
      this.datas,
      this.tagListClone,
    );
    //  使用自增序号
    this.getNextIndex();
  },

  methods: {
    updateTag(event, item, index) {
      this.datas.tagList[index] = this.tagListClone[index];
      console.log(
        "实时输入",
        event,
        item,
        index,
        this.datas,
        this.tagListClone,
      );
    },
    updateTagBlur(event, item, index) {
      // this.tagListClone[index] = this.datas.tagList[index]
      console.log(
        "失去焦点",
        event,
        item,
        index,
        this.datas,
        this.tagListClone,
      );
      Bus.$emit("send-message", this.datas);
    },
    // 获取标签内的各个组件实例
    getComponentInstances(button) {
      this.tagCollapse = button.ref;
      if (button.id === "transversustag") {
        // const obj = {
        //   title: button.text,
        //   name: button.ref,
        // };
        // this.collapseList[1] = obj;
        // this.collapseList.splice(1, 1);
      } else {
        const obj = {
          title: button.text,
          name: button.ref,
        };
        this.collapseList[1] = obj;
      }
      console.log(
        "获取标签内的各个组件实例-----------------------------------",
        button,
        this.datas,
        this.tagCollapse,
        this.currentComponent,
        this.collapseList,
      );
      //  this.$nextTick(() => {
      //     const components = this.$refs.ChildrenRightPanel;
      //     console.log("标签内的各个组件实例111111111111111", components);
      //   });
    },
    // 从indexMobile父组件操作任何子组件的函数
    setComponentStyleAnimate(button, row) {
      console.log(
        "打印右侧操作区域的组件动画节点",
        button,
        row,
        this.$refs.ChildrenRightPanel[0],
      );
      this.$refs.ChildrenRightPanel[0][button.id]();
    },
    //模块样式选择回调
    clickChange(item, index) {
      console.log(
        "模块样式点击了",
        item,
        index,
        this.datas,
        this.moduleStyleType,
      );
      this.moduleStyleType = item.moduleStyleType;
      this.datas.moduleStyleType = item.moduleStyleType;
    },
    // 获取下一个自增序号
    getNextIndex() {
      // 计算当前最大序号
      const max = this.datas.tagList.reduce((max, item) => {
        const m = item.name.match(/标签(\d+)$/);
        return m ? Math.max(max, Number(m[1])) : max;
      }, 0);
      this.nextIndex = max + 1;
      console.log("当前最大序号", max, this.nextIndex);
    },

    // 上移
    moveUp(index) {
      if (index === 0) return;
      const list = [...this.datas.tagList];
      [list[index - 1], list[index]] = [list[index], list[index - 1]];
      this.datas.tagList = list;
    },
    // 下移
    moveDown(index) {
      if (index === this.datas.tagList.length - 1) return;
      const list = [...this.datas.tagList];
      [list[index], list[index + 1]] = [list[index + 1], list[index]];
      this.datas.tagList = list;
    },
    addTag() {
      // const newDatas = { ...this.datas };
      const obj = {
        comList: [],
        comType: "none",
        name: `标签${this.nextIndex}`,
        type: this.nextIndex,
      };
      this.datas.tagList = [...this.datas.tagList, obj];
      this.datas.activeIndex = this.datas.tagList.length - 1;
      console.log("添加标签了", obj, this.datas);
      // this.$emit("update:datas", newDatas);
    },
    deleteTag(item, index) {
      console.log("删除了", item, index);
      if (this.datas.tagList.length <= 1) return; // 至少保留一项
      this.datas.tagList.splice(index, 1);
      // 关键：无论删的是谁，都自动回到第一项
      this.datas.activeIndex = 0;
    },
    // 处理文字颜色选择器变化
    handleCustomColorChange(color, type) {
      console.log("文字颜色选择事件", color, type);
      if (type === "activeColor") {
        this.$utils.setCssVariable("theme-primary", color);
      } else {
        this.datas[type] = color;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep.van-cell {
  border: none;
  padding: 0;
  line-height: 0px;
}
.transversus-tag-style {
  padding: 15px;
  background-color: #fff;
  height: 100%;
  overflow-y: auto;
  /* 容器样式 */
  .tag-table-container {
    width: 100%;
    max-width: 800px;
    margin: 20px auto;
    padding: 0 16px;
    .title-container {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 10px;
      .title {
        font-weight: 600;
      }
      .add-btn {
        border: 1px solid #323232;
        border-radius: 4px;
        padding: 4px 8px;
        cursor: pointer;
        font-size: 12px;
        font-weight: 600;
      }
      .add-btn:hover {
        /* 背景色变化 */
        background: rgba(52, 140, 248, 0.08);
        /* 增强阴影 */
        box-shadow: 0 2px 4px rgba(52, 140, 248, 0.15);
        /* 稍微上移 */
        transform: translateY(-2px);
      }
      .add-btn:active {
        transform: translateY(0);
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
      }
    }
  }
  /* 表格基础样式 */
  .tag-table {
    width: 100%;
    border-collapse: collapse;
    border: 1px solid #e5e5e5;
    background-color: #fff;
  }

  /* 表头样式 */
  .tag-table th {
    padding: 8px 12px;
    text-align: left;
    background-color: #f5f5f5;
    border-bottom: 1px solid #e5e5e5;
    font-weight: 500;
    color: #333;
    text-align: center;
  }

  /* 表格单元格样式 */
  .tag-table td {
    padding: 8px 16px;
    border-bottom: 1px solid #e5e5e5;
    color: #666;
    text-align: center;
  }
  .tag-table tr:hover {
  }
  /* 排序图标样式 */
  .sort-icon {
    color: #999;
    cursor: pointer;
  }
  .sort-icon:hover {
    color: #409eff;
  }

  /* 操作按钮区域 */
  .action-buttons {
    display: flex;
    gap: 12px;
  }

  /* 查看按钮 */
  .view-btn {
    border: none;
    background: none;
    color: #409eff;
    cursor: pointer;
    font-size: 16px;
  }

  /* 删除按钮 */
  .delete-btn {
    border: none;
    background: none;
    color: #f56c6c;
    cursor: pointer;
    font-size: 16px;
  }
  .tag-list-config {
    .tag-item-config {
      display: flex;
      align-items: center;
      margin-bottom: 8px;
    }
  }

  .font-size-config,
  .spacing-config {
    display: flex;
    align-items: center;

    .size-value,
    .spacing-value {
      margin-left: 10px;
      min-width: 40px;
      text-align: center;
      color: #606266;
    }
  }

  :deep(.el-form-item) {
    margin-bottom: 16px;
  }

  :deep(.el-divider) {
    margin: 20px 0;
  }
}
</style>
